import React from 'react';
import { OrderAutomatizaionRow } from '@/Types';
import { useFormContext } from '@/Hooks/useFormWrapper';
import { FormSelectInput } from '@/Components/Controls/SelectInput/FormSelectInput';
import { useRequired } from '@/Hooks/Validation';
import { useLocalization } from '@/Hooks';
import { useOrderPackagesOptions } from './hooks/useOrderPackagesOptions';
import { FormData } from '@/ModalWindows/OrderAutomatizationModal/hooks/useOrderAutomatizationModalForm';
import { OwnContractLogistic } from './modules/OwnContractLogistic/OwnContractLogistic';
import { ShipCheaperLogistic } from './modules/ShipCheaperLogistic/ShipCheaperLogistic';
import styles from './OrderPackagesCell.scss';
import { Icon } from '@/Components/Icon/Icon';
import { TopMenuIcons } from '@/Static/IconsRes';
import { globalHistory } from '@/GlobalHistory';
import { PagesRouting } from '@/Routing';

type Props = {
  rowIndex: number;
  rowData: OrderAutomatizaionRow;
};

export function OrderPackagesCell({ rowIndex, rowData }: Props) {
  const {
    common: {
      InputPlaceholders: { Select },
    },
  } = useLocalization();

  const {
    register,
    watch,
    formState: { errors },
  } = useFormContext<FormData>();

  // Rules
  const required = useRequired();

  // Options
  const ownContract = watch(`prepareLabels.${rowIndex}.ownContract`);

  const { contractTypeOptions } = useOrderPackagesOptions(rowData, ownContract);

  return (
    <div className={styles.packagesWrapper}>
      <div className={styles.packageSelectWithIcon}>
        <FormSelectInput<FormData>
          name={`prepareLabels.${rowIndex}.ownContract`}
          register={register}
          options={[{ key: '', value: Select }, ...contractTypeOptions]}
          needClearButton={false}
          rules={required}
          error={errors}
          disabled={rowData?.hasLabelCreated}
        />

        <Icon
          alt={''}
          src={TopMenuIcons.SettingsIcon}
          className={styles.selectInputIcon}
          onClick={() => globalHistory.push(PagesRouting.SettingsPages.LogisticSettings)}
        />
      </div>

      {ownContract === 'yes' && <OwnContractLogistic rowIndex={rowIndex} rowData={rowData} />}
      {ownContract === 'no' && <ShipCheaperLogistic rowIndex={rowIndex} rowData={rowData} />}
    </div>
  );
}
